import {IVcfTransactionHistoryMessage, VcfTransactionHistoryClient} from "./VcfTransactionHistoryClient";
import { DevicePlatform } from '../enums';

export enum MessageCategory {
    REMOTELOCKUNLOCK = 1,
    ANTITHEFTALARM,
    HONKFLASH,
    GEOFENCE,
    SPEEDALERT,
    DIGITALKEY,
    UNKNOWN
}

export enum MessageAction {
    LOCK,
    UNLOCK,
    ALARM_INTERIOR,
    ALARM_EXTERIOR,
    ALARM_MOVEMENT,
    ALARM_TRAILER,
    ALARM_UNKNOWN,
    HONK,
    FLASH,
    HONKFLASH,
    EXIT_GREENZONE,
    ENTER_REDZONE,
    START_EXCEEDING,
    MK_INSTALLED,
    PERMISSION_DECLINED,
    PERMISSION_GRANTED,
    PERMISSION_VTAN_REJECTED,
    PERMISSION_REVOKED_VERWALTER,
    PERMISSION_AND_MK_REVOKED_VERWALTER,
    PERMISSION_RETURNED,
    MK_RETURNED,
    PERMISSION_EXPIRED,
    PERMISSION_AND_MK_EXPIRED,
    MK_REMOVAL_SUCCEEDED_VERWALTER,
    MK_REMOVAL_FAILED_VERWALTER,
    MK_EXTENDED,
    UNKNOWN
}

export interface IMessage {
    readonly category: MessageCategory;
    readonly timestamp?: string;
    readonly action: MessageAction;
    readonly actionSuccess?: boolean;
    readonly alertName?: string;
    readonly keyName?: string;
    readonly keyUserName?: string;
}

export class VcfMessageService {
    constructor(private readonly vcfTransactionHistoryClient: VcfTransactionHistoryClient) {
    }

    public async getMessages(vin: string, devicePlatform: DevicePlatform): Promise<IMessage[]> {
        const isWcar = devicePlatform === DevicePlatform.WCAR;
        const transactionHistoryResponse = await this.vcfTransactionHistoryClient.getTransactionHistory(vin, isWcar);
        return this.filterAndTransformAndSort(transactionHistoryResponse.data?.messages ?? []);
    }

    public async deleteMessage(vin: string, devicePlatform: DevicePlatform, category: MessageCategory): Promise<void> {
        const validCategories = [MessageCategory.ANTITHEFTALARM, MessageCategory.GEOFENCE, MessageCategory.SPEEDALERT];
        if (validCategories.includes(category)) {
            const isWcar = devicePlatform === DevicePlatform.WCAR;
            return this.vcfTransactionHistoryClient.deleteTransactionHistory(vin, isWcar, MessageCategory[category]!.toLowerCase());
        }
    }

    private filterAndTransformAndSort(messages: IVcfTransactionHistoryMessage[]): IMessage[] {
        return messages.map(this.transformVcfTransactionHistoryMessageToMessage)
            .filter((entry) => entry.action !== MessageAction.UNKNOWN)
            .sort(this.sortMessagesByTimestamp);
    }

    private sortMessagesByTimestamp(message1: IMessage, message2: IMessage) {
        const firstDate = message1.timestamp ? new Date(message1.timestamp) : new Date();
        const secondDate = message2.timestamp ? new Date(message2.timestamp) : new Date();
        return secondDate.getTime() - firstDate.getTime();
    }

    private transformVcfTransactionHistoryMessageToMessage(message: IVcfTransactionHistoryMessage): IMessage {
        return {
            category: (MessageCategory as any)[message.category?.toUpperCase() ?? ''] ?? MessageCategory.UNKNOWN,
            timestamp: message.timestamp,
            action: (MessageAction as any)[message.action?.toUpperCase() ?? ''] ?? MessageAction.UNKNOWN,
            actionSuccess: message.actionSuccess,
            alertName: message.alertName,
            keyName: message.keyName,
            keyUserName: message.keyUserName
        };
    }
}